import { AnyAction, combineReducers } from "@reduxjs/toolkit";

import alert from "./alert/alertSlice";
import credential from "./credential/credentialSlice";
import loading from "./loading/loadingSlice";
import theme from "./theme/themeSlice";
import template from "./template/templateSlice";
import userInfo from "./userInfo/userInfoSlice";
import certificate from "./certificate/certificateSlice";
import document from "./document/documentSlice"; // Add this line

const appReducer = combineReducers({
  // app
  alert,

  // credential
  credential,

  // certificate
  certificate,

  // loading
  loading,

  // theme
  theme,

  // user
  userInfo,

  // template
  template,

  // document orientation
  document,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined = undefined,
  action: AnyAction
) => {
  if (action.type === "user/logOut") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
